// Quiz.js
// Expose a namespace

const confetti = require('canvas-confetti');

globalThis.IWWQuiz = {
    init: function({ containerSelector = '.iww-quiz', jsonData = null } = {}) {
        const container = document.querySelector(`div${containerSelector}`);
        const intro = document.getElementsByClassName("iww-quiz-inhalte")[0];
        const button = intro.querySelectorAll("#quiz_btn")[0];

        button.addEventListener("click", () => {
            
            const card = container.querySelector('#quiz-card');
            let quizData = jsonData;
            if (!quizData) {
                try {
                    quizData = JSON.parse(container.dataset.quizJson);
                } catch (err) {
                    card.innerHTML = `<div class="text-destructive font-bold">Quiz konnte nicht geladen werden: ${err}</div>`;
                    return;
                }
            }
            
            intro.innerHTML = "";
            document.querySelector(".iww-quiz-fragen").style.display = "block";
            startQuiz(quizData, card, intro);

        })

        function startQuiz(quizData, quizCard, intro) {
            let selectedQuestions = [];
            let currentIndex = 0;
            let userAnswers = [];

            function shuffleArray(arr) {
                return arr.map(v => ({ sort: Math.random(), value: v }))
                    .sort((a, b) => a.sort - b.sort)
                    .map(v => v.value);
            }

            function initQuiz() {
                let questions = quizData.fragen;

                if (quizData.fragenRandomisieren) questions = shuffleArray(questions);
                if (quizData.fragenLimitieren) {
                    const limit = parseInt(quizData.anzahlFragen, 10);
                    questions = questions.slice(0, limit);
                }

                selectedQuestions = questions;
                currentIndex = 0;
                userAnswers = [];
                showQuestion();
            }

            function showQuestion() {
                const q = selectedQuestions[currentIndex];

                q.fragenContent.forEach(({content, type}) => {
                    if (type === "Ueberschrift" && content != null && content != "") {
                        intro.innerHTML = `<span class="text-xl xmd:text-2xl xl:text-3xl text-neutral font-medium mb-3 block">${content}</span>`;
                    } else if (type === "Absatz" && content != null && content != "") {
                        intro.innerHTML = `<p class="w-full text-neutral text-base xmd:text-lg xl:text-xl mb-7">${content}</p>`;
                    }
                })

                quizCard.innerHTML = `
          <div class="bg-surface-elevated-background shadow-lg rounded-xl p-6 max-w-lg mx-auto">
            <h2 class="text-xl font-semibold mb-4">Frage ${currentIndex + 1} von ${selectedQuestions.length}</h2>
            <p class="mb-4">${q.frage}</p>
            <div class="answers space-y-2">
              ${q.antworten.map((a, i) => `
                <label class="flex items-center space-x-2">
                  <input type="checkbox" name="answer" value="${i}" class="form-checkbox h-5 w-5 text-blue-600"/>
                  <span>${a.antwort}</span>
                </label>`).join('')}
            </div>
            <div class="navigation flex justify-between mt-6">
              ${currentIndex>0 ? '<button id="prevBtn" class="px-6 py-4 border-buttongradientlight hover:border-buttongradientdark border-2 rounded-full inline-flex justify-center items-center text-center justify-center text-buttongradientlight hover:text-buttongradientdark text-base font-medium leading-none">Zurück</button>' : '<span></span>'}
              <button
                  id="nextBtn"
                  class="px-6 py-4 bg-linear-to-b from-buttongradientlight to-buttongradientdark hover:from-buttongradientdark hover:to-buttongradientdark rounded-full inline-flex justify-center items-center text-center text-white text-base font-medium leading-none"
                  ${currentIndex === selectedQuestions.length - 1 ? 'data-gtm-event="quiz_finish"' : ''}
                >
                  ${currentIndex === selectedQuestions.length - 1 ? 'Fertig' : 'Weiter'}
                </button>
            </div>
          </div>
        `;

                if (userAnswers[currentIndex]) {
                    userAnswers[currentIndex].forEach(i => {
                        quizCard.querySelector(`input[value="${i}"]`).checked = true;
                    });
                }

                quizCard.querySelector('#nextBtn').addEventListener('click', nextQuestion);
                if (currentIndex > 0) quizCard.querySelector('#prevBtn').addEventListener('click', prevQuestion);
            }

            function nextQuestion() {
                const selected = Array.from(quizCard.querySelectorAll("input[name=answer]:checked"))
                    .map(i => parseInt(i.value));
                userAnswers[currentIndex] = selected;

                if (currentIndex === selectedQuestions.length - 1) {
                    showResults(intro);
                } else {
                    currentIndex++;
                    showQuestion();
                }
            }

            function prevQuestion() {
                const selected = Array.from(quizCard.querySelectorAll("input[name=answer]:checked"))
                    .map(i => parseInt(i.value));
                userAnswers[currentIndex] = selected;
                currentIndex--;
                showQuestion();
            }

            function showResults(intro) {
                quizCard.innerHTML = "";
                intro.innerHTML = "";
                
                const outro = document.getElementsByClassName("iww-quiz-outro")[0];

                const resultsBlock = outro.querySelectorAll("#results")[0];
                let correctCount = 0;

                selectedQuestions.forEach((q, qi) => {
                    const correctIndices = q.antworten.map((a,i)=>({...a,i})).filter(a=>a.antwortKorrekt).map(a=>a.i);
                    const selected = userAnswers[qi]||[];
                    const isCorrect = correctIndices.length===selected.length && correctIndices.every(i=>selected.includes(i));
                    if(isCorrect) correctCount++;

                    resultsBlock.innerHTML += `
            <div class="p-4 rounded-lg ${isCorrect ? 'bg-green-100' : 'bg-destructive/10'}">
              <p class="font-semibold">Frage ${qi+1}: ${q.frage}</p>
              <p>Deine Antwort: ${selected.map(i=>q.antworten[i].antwort).join(", ")||"keine"}</p>
              <p>Richtige Antwort: ${correctIndices.map(i=>q.antworten[i].antwort).join(", ")}</p>
              <p class="${isCorrect ? 'text-green-700 font-bold' : 'text-destructive font-bold'}">${isCorrect?"✅ Richtig":"❌ Falsch"}</p>
            </div>
          `;
                });

                outro.querySelectorAll("#points")[0].textContent = `Gesamtpunktzahl: ${correctCount} / ${selectedQuestions.length}`
                const messageBlock = outro.querySelectorAll("#resultMessage")[0];
                const resultMessages = JSON.parse(messageBlock.dataset.quizResultMessages);

                if (resultMessages.resultMessages.length > 0){
                    const resultMessage = resultMessages.resultMessages.find((message) => {
                        return message.minPunkte <= correctCount && message.maxPunkte >= correctCount;
                    })
                
                    messageBlock.innerHTML = `<p class="text-lg font-bold mt-4">${resultMessage.nachricht}</p>`
                }
                
               
                outro.style.display = "block"

                const confettiData = JSON.parse(outro.dataset.confettiJson);
                
                if (confettiData.confettiEnabled === true){
                    if (confettiData.confettiPoints <= correctCount){
                        confetti({
                            particleCount: 100,
                            spread: 70,
                            origin: {
                                y: 0.6
                            }
                        })
                    }
                }

                outro.querySelector('#quiz_btn').addEventListener('click', () => {
                    outro.querySelector("#results").innerHTML = "";
                    outro.style.display = "none";
                    document.documentElement.scrollTop = 0;
                    initQuiz();
                });
            }

            initQuiz();
        }
    }
};
